import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/salesContent';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % recentBuyers.length);
      }, 5500);
    };
    const first = setTimeout(show, 7000);
    const interval = setInterval(show, 16000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 sm:right-auto" aria-live="polite" data-id="element-40" data-mp="1gz6umgfaccrk">
      <AnimatePresence data-id="element-41" data-mp="165pka9e6cobd">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-start gap-3 rounded-xl border border-gold/40 bg-ink p-3.5 pr-9 shadow-[0_12px_32px_rgba(0,0,0,0.5)] sm:w-80" data-id="element-42" data-mp="16466cpfzqpcr">
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gold/50 text-gold" data-id="element-43" data-mp="i9v1ev1f8v6q">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="s67w9w8pdf32" />
            </span>
            <div className="min-w-0 text-sm leading-snug" data-id="element-45" data-mp="s8kl8tcvoppm">
              <p className="font-semibold text-gold" data-id="element-46" data-mp="28j4z2hjmu61y">Compra reciente</p>
              <p className="mt-0.5 text-cream" data-id="element-47" data-mp="23lwhoj6b661r">
                <span className="font-semibold" data-id="element-48" data-mp="23l3ka8t8oswa">{recentBuyers[index].name}</span> de {recentBuyers[index].city}, Argentina accedió al{' '}
                <span className="font-semibold text-yellow-300" data-id="element-49" data-mp="2fne9xinriwsc">Primeros Auxilios para Instructores™</span>
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded p-1 text-neutral-500 transition-colors duration-150 hover:text-cream" data-id="element-50" data-mp="2ko27kn6hybvj">
              <XIcon className="h-4 w-4" data-id="element-51" data-mp="1rzwn81jcuow8" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}